// extracted by mini-css-extract-plugin
export default {"wrap":"EditProductInstanceDialog-wrap","redirectUriRequirements":"EditProductInstanceDialog-redirectUriRequirements","formLabel":"EditProductInstanceDialog-formLabel"};